import { Raw } from '@/modules/common/helpers/api';
import { ParseOmsBasketResponse } from '@/modules/marketplace/models';
import { OmsBasketItem, OrderBasketParams, RawOmsBasketItem } from '@/modules/marketplace/models';

export type RawCreateOmsBasketRequest = Raw<
  CreateOmsBasketRequest,
  {
    // always specify existing raw entry types explititly
    entries: RawOmsBasketItem[];
  }
>;

export class CreateOmsBasketRequest extends OrderBasketParams {
  public basketId: string;

  protected constructor(data: RawCreateOmsBasketRequest) {
    super(data);
    this.basketId = data.basketId;
  }

  public static fromData(data: RawCreateOmsBasketRequest): CreateOmsBasketRequest {
    return new CreateOmsBasketRequest(data);
  }

  public static fromParseOmsBasketResponse(data: ParseOmsBasketResponse): CreateOmsBasketRequest {
    return new CreateOmsBasketRequest({
      basketId: crypto.randomUUID(),
      companyId: data.companyId,
      userId: data.userId,
      side: data.side,
      entries: data.entries.map((e) => OmsBasketItem.toData(e, data.agreementIds)),
      agreementIds: data.agreementIds,
      allowOddLots: data.allowOddLots,
    });
  }

  public static toData(model: CreateOmsBasketRequest): RawCreateOmsBasketRequest {
    return { ...OrderBasketParams.toData(model), basketId: model.basketId };
  }
}
